import React, { Component } from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'
import { stores, view } from '../../../stores'
import { Loader } from '../../ui/states/Loader'

import './Rewards.css'
import { RewardItem } from './RewardItem'
import { Accordion } from '../../accordion/Accordion'

class RewardsComponent extends Component {
  async componentDidMount () {
    await stores.account.getRewards()
  }

  render () {
    const { t } = this.props
    const { rewards } = stores.account
    const isRewardsPresent = rewards && rewards.content && rewards.content.length > 0

    return (
      <div className='box box--grey'>
        <div>
          {
            stores.account.wallet.loading
              ? <Loader size='small' />
              : <span>{t('common:account:rewards:available_points', { points: rewards.availablePoints })}</span>
          }
        </div>
        <Accordion title={t('common:account:rewards:used_rewards')} additionalComponent={
          <div>
            {
              isRewardsPresent
                ? rewards.content.map((reward, index) => {
                  return <RewardItem reward={reward} index={index} key={index} t={t} />
                })
                : <p className='rewards__present__section__date'>{t('common:account:rewards:no_used_rewards')}</p>
            }
          </div>
        } />
      </div>
    )
  }
}

RewardsComponent.propTypes = { t: func }

export const Rewards = translate()(view(RewardsComponent))



// WEBPACK FOOTER //
// ./src/components/customer/rewards/Rewards.js